import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { StorageService } from './storage.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FoodOption } from '../interfaces/food-option';

@Injectable({
  providedIn: 'root',
})
export class FoodOptionService {
  FOOD_apiUrl = environment.apiUrl + '/food-options';

  constructor(
    private storageService: StorageService,
    private http: HttpClient
  ) {}

  //FoodOption CRUD

  createFood(foodOption: FoodOption): Observable<void> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.post<void>(
      this.FOOD_apiUrl,
      { ...foodOption },
      { headers: httpHeaders }
    );
  }

  updateFood(foodOption: FoodOption): Observable<void> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.put<void>(
      this.FOOD_apiUrl,
      { ...foodOption },
      { headers: httpHeaders }
    );
  }

  deleteFood(foodId: number): Observable<void> {
    const token = this.storageService.get('accessToken', false);
    const httpHeaders = new HttpHeaders().set('Access-Token', token);

    return this.http.delete<void>(`${this.FOOD_apiUrl}/${foodId}`, {
      headers: httpHeaders,
    });
  }
}
